import type { TourDefinition } from '@renderer/hooks/useTour';

/**
 * Sprint 26 — Tour del wizard "Precargar inventario" (Sprint 25).
 *
 * Cubre el flujo de la mañana: el sistema sugiere cuánto cargar de cada
 * insumo basado en lo vendido ayer; la dueña acepta, ajusta o salta.
 */
export const tourPrecargar: TourDefinition = {
  id: 'precargar_inventario',
  title: 'Cómo precargar el inventario',
  steps: [
    {
      element: '[data-tour="pre-header"]',
      popover: {
        title: '1. Precarga del día',
        description:
          'El sistema mira lo vendido AYER y te sugiere cuánto cargar HOY de cada insumo. Te ahorra capturar a mano cada mañana.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="pre-filtros"]',
      popover: {
        title: '2. Filtra solo lo que necesita acción',
        description:
          'Por defecto verás solo los insumos con sugerencia > 0 (ya descontando lo que tienes en stock). Cambia a "Todos" si quieres cargar manual algo extra.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="pre-cards"]',
      popover: {
        title: '3. Una tarjeta por insumo',
        description:
          'Cada card te dice cuánto TIENES, cuánto VENDISTE ayer y cuánto te sugiere CARGAR. Ajusta con − / + si recibiste otra cantidad, y toca ✓ Aceptar o ⊘ Saltar.',
        side: 'top',
      },
    },
    {
      element: '[data-tour="pre-final"]',
      popover: {
        title: '4. Cargar todo aceptado',
        description:
          'Cuando termines, este botón ejecuta TODA la carga en una sola operación. El stock sube de inmediato y vuelves a Inventario. 3 clics vs 10 minutos capturando.',
        side: 'top',
      },
    },
  ],
};
